import UserService from '@/services/user.service';
import axios from "axios";

export const studentModule = {
    namespaced: true,
    state: {
        requests: [],
        student: {},
        students: new Map(),
        comments: new Map(),
    },
    actions: {
        clearRequest({state}, name) {
            state.requests = state.requests.filter(obj => obj.requestName !== name);
        },
        makeOrCancelRequest({state}, name) {
            const requestExist = state.requests.find((item) => {
                return item.requestName === name ? item : null
            })

            if (requestExist)
                requestExist.cancel()

            const axiosSource = axios.CancelToken.source();

            state.requests = state.requests.filter(obj => obj.requestName !== name);
            state.requests.push({requestName: name, cancel: axiosSource.cancel});

            return axiosSource;
        },
        async createStudent({commit, dispatch}, data) {
            const axiosSource = await dispatch('makeOrCancelRequest', "createStudent");
            data.role_id = '$student'
            return UserService.createUser(axiosSource, data).then(
                async data => {
                    commit('insertStudent', data)
                    await dispatch('clearRequest', "createStudent");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async updateStudent({commit, dispatch}, data) {
            const axiosSource = await dispatch('makeOrCancelRequest', "updateStudent");
            return UserService.updateUser(axiosSource, data).then(
                async data => {
                    commit('updateStudentData', data)
                    await dispatch('clearRequest', "updateStudent");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async deleteStudent({commit, dispatch}, studentId) {
            const axiosSource = await dispatch('makeOrCancelRequest', "deleteStudent");
            return UserService.deleteUser(axiosSource, studentId).then(
                async data => {
                    commit('removeStudentFromList', studentId)
                    await dispatch('clearRequest', "deleteStudent");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async getStudent({commit, dispatch}, studentId) {
            const axiosSource = await dispatch('makeOrCancelRequest', "getStudent");
            return UserService.getUser(axiosSource, studentId).then(
                async data => {
                    commit('updateActiveStudent', data)
                    await dispatch('clearRequest', "getStudent");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        listStudents({commit}) {
            return UserService.listUsersByRole('$student').then(
                data => {
                    commit('updateStudentsList', data);
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async listStudentComments({commit, dispatch}, studentId) {
            const axiosSource = await dispatch('makeOrCancelRequest', "listStudentComments");
            return UserService.listUserComments(axiosSource, studentId).then(
                async data => {
                    commit('updateCommentsList', data);
                    await dispatch('clearRequest', "listStudentComments");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async createStudentComment({commit, dispatch}, {studentId, data}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "createStudentComment");
            return UserService.createUserComment(axiosSource, studentId, data).then(
                async data => {
                    commit('insertComment', data);
                    await dispatch('clearRequest', "createStudentComment");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
        async deleteStudentComment({commit, dispatch}, {studentId, commentId}) {
            const axiosSource = await dispatch('makeOrCancelRequest', "deleteStudentComment");
            return UserService.deleteUserComment(axiosSource, studentId, commentId).then(
                async data => {
                    commit('removeCommentFromList', commentId);
                    await dispatch('clearRequest', "deleteStudentComment");
                    return Promise.resolve(data);
                },
                error => {
                    return Promise.reject(error);
                }
            );
        },
    },
    mutations: {
        updateStudentsList(state, data) {
            state.students = new Map()
            for (const entity of data) {
                entity.phone = entity.phone?.replace('+98', '0')
                state.students.set(entity.id, entity)
            }
        },
        insertStudent(state, data) {
            state.students.set(data.id, data)
        },
        updateStudentData(state, data) {
            state.students.set(data.id, data)
        },
        removeStudentFromList(state, studentId) {
            state.students.delete(studentId)
        },
        updateActiveStudent(state, data) {
            data.phone = data.phone?.replace('+98', '0')
            state.student = data;
        },
        updateCommentsList(state, data) {
            state.comments = new Map()
            for (const entity of data) {
                state.comments.set(entity.id, entity)
            }
        },
        insertComment(state, data) {
            state.comments.set(data.id, data)
        },
        removeCommentFromList(state, commentId) {
            state.comments.delete(commentId)
        },
    }
};